export default "__VITE_ASSET__CbwPl_r0__"